import { render, staticRenderFns } from "./WordStructure.vue?vue&type=template&id=292fee1b&lang=pug&"
import script from "./WordStructure.vue?vue&type=script&lang=js&"
export * from "./WordStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports